import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const TestAdminRoute: React.FC = () => {
  const { user, profile, loading } = useAuth();

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Admin Route Test Page</h1>
      
      <div className="space-y-4">
        <div className="bg-gray-100 p-4 rounded">
          <h2 className="font-semibold">Loading State:</h2>
          <pre>{JSON.stringify({ loading }, null, 2)}</pre>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="font-semibold">User:</h2>
          <pre>{JSON.stringify({ id: user?.id, email: user?.email }, null, 2)}</pre>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="font-semibold">Profile:</h2>
          <pre>{JSON.stringify(profile, null, 2)}</pre>
        </div>

        <div className="bg-gray-100 p-4 rounded">
          <h2 className="font-semibold">Is Admin:</h2>
          <p>{profile?.role === 'admin' || profile?.role === 'super_admin' ? 'YES' : 'NO'}</p>
          <p>Role: {profile?.role || 'UNDEFINED'}</p>
        </div>

        <div className="mt-8 space-x-4">
          <a href="/admin" className="bg-blue-500 text-white px-4 py-2 rounded">
            Try /admin route
          </a>
          <a href="/dashboard" className="bg-gray-500 text-white px-4 py-2 rounded">
            Back to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default TestAdminRoute;
